export enum EmbeddedAppPathname {
    Dashboard = '/dashboard',
    Settings = '/settings',
    Credentials = '/credentials',
    TalentCrm = '/talent-crm',
}
